import classNames from 'classnames';
import { ReactNode } from 'react';

import styles from './TopRight.module.css';

type Space = 'small' | 'none' | 'negativeSmall';

type TopRightProps = { children: ReactNode; top?: Space; right?: Space };

const TopRight = ({
    top = 'small',
    right = 'small',
    children,
}: TopRightProps) => (
    <div
        className={classNames(styles.Root, {
            [styles.topSmall]: top === 'small',
            [styles.topNone]: top === 'none',
            [styles.topNegativeSmall]: top === 'negativeSmall',
            [styles.rightSmall]: right === 'small',
            [styles.rightNone]: right === 'none',
            [styles.rightNegativeSmall]: right === 'negativeSmall',
        })}
    >
        {children}
    </div>
);

export default TopRight;
